import { initSentry as initSentryFromConfig } from './SentryConfig'

export const initSentry = window => {
  initSentryFromConfig(window)
}
